<div class="cm-detail">
    <cm-list-item
        [disabled]="false"
        [expandable]="$expandable()"
        [expanded]="$expandable() ? $infoTree().treeControl.isExpanded($treeItem()) : false"
        (arrowToggle)="$infoTree().treeControl.toggle($treeItem())"
    >
        <ng-container cm-pre-title>
            <div class="cm-title-icons-container">
                <i class="cm-node-icon" [class]="$nodeIconClass()" [matTooltip]="$tooltip()"></i>
            </div>
        </ng-container>
        <ng-container cm-title>
            <span class="cm-list-item-title-text cm-offset-icons">
                <span [matTooltip]="$label()">{{ $label() }}</span>
                @if ($secondaryNodeIconClass(); as secondaryIconClass) {
                    <i class="cm-node-icon" [class]="secondaryIconClass" [matTooltip]="$tooltip()"></i>
                }
            </span>
        </ng-container>
    </cm-list-item>
    <div class="cm-detail-column">
        <cm-template-tree-scene-node-aggregation
            [input]="$aggregatedSceneNodes()"
            [sceneAggregationMode]="$infoTree().$templateTreeItem().$templateTree().$sceneAggregationMode()"
        >
        </cm-template-tree-scene-node-aggregation>
    </div>
</div>
